function init(){
const body = document.body;
const menus = {
	contact: {
		triggerClass:'header__contact',
		contentClass: 'header__contact-list',
	},
	headerLanguage: {
		triggerClass:'header__language',
		contentClass: 'header__language-list',
	},
	headerMenu: {
		triggerClass:'header__menu',
		contentClass: 'header__menu-body',
	},
	footerLanguage: {
		triggerClass:'footer__language',
		contentClass: 'footer__language-list',
	},
	footerSubmenus: {
		triggerClass:'footer__card-menu-item',
		contentClass: 'footer__card-sublist',
	},
}
const tabs = {
	links: {
		triggerClass:'header__links',
	},
	contacts: {
		triggerClass:'header__contacts',
	},
	footer: {
		triggerClass:'footer__card-title',
		contentClass: 'footer__card-list',
	},
}
const mores = {
	footer: {
		triggerClass: 'footer__more',
		hideContentClass: 'footer__card-list--hidden',
		showedListLength: 11,
	},
}
const closeAllMenus = closeMenus(menus);
const showModalById = showModal({
	closeButtonClass: 'popup__modal-close',
	modalContentClass: 'modal',
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const hideCurrentModal = hideModal({
	visibleClass: 'modal__active',
	modalWrapperClass: 'modal-overlay'
});
const tags = [ 'INPUT', 'TEXTAREA' ];
const actions = {
	openModal: ({ openModal }) => {
		closeAllMenus();
		showModalById(openModal);
	},
}
// const timeLabelElements = getCountryTimeLabelElements([
// 	'header__contact-time',
// 	'header__contacts-time',
// 	'footer__card-time',
// 	'contact__country-time',
// ]);


for (const prop in menus) {
	body.addEventListener('click', toggleMenu(menus[prop], closeAllMenus));
}

for (const prop in tabs) {
	body.addEventListener('click', toggleTab(tabs[prop]));
}

for (const prop in mores) {
	const moreElements = document.getElementsByClassName(mores[prop].triggerClass)
	const toggleMoreCb = toggleMore(mores[prop])

	for (const moreElement of moreElements) {
		toggleMoreCb({ target: moreElement });
	}

	body.addEventListener('click', toggleMoreCb);
}

setCooperateFormHandlers();
setToDirectorFormHandlers();
setContactFormHandlers();
// setCountryTimeLabelOffsetAndTime(timeLabelElements);
setRefreshCountryTimeInterval();
// setLanguagesAndLinks([
// 	...document.getElementsByClassName('header__language-list'),
// 	...document.getElementsByClassName('footer__language-list'),
// ]);
loadGoogleAnalytics();
body.addEventListener('click', (e) => {
	const { target } = e

	for (const prop in menus) {
		const { triggerClass, contentClass } = menus[prop];
		const menuTrigger = target.closest('.' + triggerClass);
		const menuContent = target.closest('.' + contentClass);

		if (menuTrigger || menuContent) {
			return;
		}
	}

	closeAllMenus();
});
body.addEventListener('click', createAnchorClickHandler(actions));

setItiPhoneInputs(intlTelInput);

removePreviewAndLoadSwiperStyles();

new Swiper(".contact__countries", {
	slidesPerView: 1,
	spaceBetween: 20,
	breakpoints: {
		320: {
			slidesPerView: 1,
			spaceBetween: 16,
			grid: {
				fill: 'row',
				rows: 1
			},
		},
		769: {
			slidesPerView: 1,
			grid: {
				fill: 'row',
				rows: 2
			},
		},
		993: {
			slidesPerView: 2,
			grid: {
				fill: 'row',
				rows: 2
			},
		},
		1201: {
			slidesPerView: 4,
			grid: {
				fill: 'row',
				rows: 2
			},
		}
	},
});

function setItiPhoneInputs (intlTelInput) {
	if (!intlTelInput) {
		return;
	}

	// const default_country_code = 'us';
	const setCountryCode = (country) => {
		intlTelInput(document.getElementById('cooperate_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
		// intlTelInput(document.getElementById('contact_phone'), {
		// 	autoHideDialCode: false,
		// 	autoPlaceholder: 'aggressive',
		// 	initialCountry: 'auto',
		// 	separateDialCode: true,
		// 	formatOnDisplay: false,
		// 	preferredCountries: [
		// 		'ua',
		// 		'us'
		// 	],
		// 	customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
		// 		return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
		// 	},
		// 	geoIpLookup: cb => cb(country),
		// });
		intlTelInput(document.getElementById('to_director_phone'), {
			autoHideDialCode: false,
			autoPlaceholder: 'aggressive',
			initialCountry: 'auto',
			separateDialCode: true,
			formatOnDisplay: false,
			preferredCountries: [
				'ua',
				'us'
			],
			customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
				return '' + selectedCountryPlaceholder.replace(/[0-9]/g, 'X');
			},
			geoIpLookup: cb => cb(country),
		});
	}

	getCountryCode().then(setCountryCode);

	// sendRequest('https://ipapi.co/json')
	// 	.then((res) => res.json())
	// 	.then(({ country_code }) => {
	// 		setCountryCode(country_code || default_country_code)
	// 	})
	// 	.catch(e => {
	// 		setCountryCode(default_country_code)
	// 	});
}
function setContactFormHandlers () {
	const contactForm = document.getElementsByClassName('send__form')[0];

	if (!contactForm) {
		return;
	}

	const checkInputValue = checkInput({ groupClass: 'send__form-group' });
	const hideInputError = hideError({ groupClass: 'send__form-group' });

	for (const element of contactForm.elements) {
		const { tagName } = element;

		if (tags.includes(tagName)) {
			savePlaceholder(element);
			element.addEventListener('focus', hideInputError);
			element.addEventListener('focus', hidePlaceholder);
			element.addEventListener('blur', checkInputValue);
			element.addEventListener('blur', showPlaceholder);
		}
	}

	contactForm.addEventListener('submit', async (e) => {
		e.preventDefault();
		const body = validateForm(e.target);

		if (!body.isValid) {
			body.errorInputs.forEach(input => checkInputValue({ target: input }));

			return;
		}

		showModalById('loader-modal');
		sendRequestAndSaveToken('/api/create_contact_order', {
			method: 'POST', body: JSON.stringify({
				full_name: body.full_name,
				message: body.message,
				// phone: body.phone,
				email: body.email,
				url: window.location.pathname || '/',
			})
		}).then(({ response }) => {
			const loader = document.getElementById('loader-modal');

			hideCurrentModal({ target: loader });

			if (!response || !response.success) {
				showModalById('error-modal');

				return;
			}

			const { request_id, success, error_text } = response;

			// console.log({ success, error_text, request_id });

			showModalById('success-modal');
			e.target.reset();
		}).catch(e => {
			console.error(e.message);
			showModalById('error-modal');
		});
	});
}

}init();